import { MealFeedbackRequest } from "@/clients/models/MealFeedbackRequest";
import { MealFeedbackService } from "@/clients/services/MealFeedbackService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useSubmitMealFeedback = () => {
  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.MEAL_FEEDBACK],
    mutationFn: async (requestBody: MealFeedbackRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await MealFeedbackService.submitMealFeedbackApiV1MealsFeedbackPost(
        user.id,
        requestBody,
      );
      return data;
    },
  });

  return {
    submitMealFeedback: mutate,
    submitMealFeedbackAsync: mutateAsync,
    isSubmitting: isPending,
    isError,
    error,
  };
};
